import {css} from 'lit'; export default css`:host{outline:0;display:flex}:host chameleon-avatar{border:none}:host goto-presence-indicator:focus{outline:0}`;
    